// CSS Modules - component class name prefix: Footer__

<template>
  <footer :class="$style.container">
    <WishList
      :config="{
        serviceUrl: '/rest-services/wishlist/send',
        ftlUrl:
          'http://www-qa.wika.dev.intern.etecture.de/de-de/merkzettel-mail-template.ftl',
        title: 'Merkzettel',
        emailPlaceholder: 'E-Mail',
        buttonText: 'Merkzettel',
        emailErrorMessage: 'Die E-Mail-Adresse hat ein falsches Format.',
        formErrorMessage:
          'Zur Zeit befinden sich keine Dokumente auf Ihrem Merkzettel.',
        technicalErrorMessage: 'Es ist ein technischer Fehler aufgetreten.',
        successMessage: 'Die E-Mail wurde erfolgreich versendet.',
        counterText: 'Dokumente',
        emptyText:
          'Zur Zeit befinden sich keine Dokumente auf Ihrem Merkzettel. Sie können alle Dokumente aus dem Bereich Download zu Ihrem Merkzettel hinzufügen. Wählen Sie hierzu die gewünschte Sprache über das Flaggensymbol.',
        formText:
          'Um Ihren Downloadlink per E-Mail zu erhalten, tragen Sie hier Ihre Adresse ein:',
        type: 'Typ',
        types: 'Typen'
      }"
    />
    <div
      :class="[$style.main, 'columns', 'is-multiline', 'is-variable', 'is-5']"
    >
      <div
        :class="[
          $style.links,
          'column',
          'is-half-tablet',
          'is-one-quarter-desktop'
        ]"
      >
        <ul>
          <li v-for="(link, index) in footerLinksOne" :key="index">
            <a :href="link.url" :target="link.newWindow ? '_blank' : '_self'">
              {{ link.title }}
            </a>
          </li>
        </ul>
      </div>
      <div
        :class="[
          $style.links,
          'column',
          'is-half-tablet',
          'is-one-quarter-desktop'
        ]"
      >
        <ul>
          <li v-for="(link, index) in footerLinksTwo" :key="index">
            <a :href="link.url" :target="link.newWindow ? '_blank' : '_self'">
              {{ link.title }}
            </a>
          </li>
        </ul>
      </div>
      <div
        :class="[
          $style.contact,
          'column',
          'is-half-tablet',
          'is-one-quarter-desktop'
        ]"
      >
        <div :class="$style.title">Kontakt</div>
        <p>WIKA Alexander Wiegand SE &amp; Co. KG</p>
        <p>Alexander-Wiegand-Str. 30 <br />63911 Klingenberg - Deutschland</p>
        <p>Tel.: +49 9372 132-0</p>
        <p>E-Mail: <a href="mailto:info@wika.de">info@wika.de</a></p>
      </div>
      <NewsletterQuickSubscription
        :config="{
          title: 'WIKA-Newsletterd',
          text: 'Erhalten Sie aktuelle Informationen und Neuigkeiten von WIKA.',
          errorMessage: 'Bitte tragen Sie eine valide E-Mail-Adresse ein.',
          placeholder: 'E-Mail-Adresse',
          newsletterFormUrl: 'newsletter-form.html'
        }"
      />
    </div>
    <div
      :class="[
        $style.nav,
        'columns',
        'is-vcentered',
        'is-multiline',
        'is-variable',
        'is-5'
      ]"
    >
      <div :class="[$style.copyright, 'column']">
        <span>© 2019 WIKA Alexander Wiegand SE &amp; Co. KG</span>
      </div>
      <SocialLinks :socialLinks="socialLinks" />
    </div>
  </footer>
</template>

<script>
import SocialLinks from "../SocialLinks/SocialLinks.vue";
import WishList from "../WishList/WishList.vue";
import NewsletterQuickSubscription from "../NewsletterQuickSubscription/NewsletterQuickSubscription.vue";

export default {
  name: "Footer",
  components: {
    SocialLinks,
    WishList,
    NewsletterQuickSubscription
  },
  data() {
    return {
      footerLinksOne: [
        {
          title: "Impressum",
          url: "#",
          newWindow: "false"
        },
        {
          title: "Datenschutzhinweise",
          url: "#",
          newWindow: "false"
        },
        {
          title: "AGB",
          url: "#",
          newWindow: "true"
        },
        {
          title: "Bankverbindung",
          url: "#",
          newWindow: "false"
        }
      ],
      footerLinksTwo: [
        {
          title: "Stellenmarkt",
          url: "#",
          newWindow: "false"
        },
        {
          title: "Häufige Fragen",
          url: "#",
          newWindow: "false"
        },
        {
          title: "Einheiten-Umrechner",
          url: "#",
          newWindow: "false"
        },
        {
          title: "Blog",
          url: "#",
          newWindow: "false"
        }
      ],
      socialLinks: [
        {
          url: "#",
          newWindow: "true",
          icon: "fab fa-youtube",
          color: "#e62117"
        },
        {
          url: "#",
          newWindow: "true",
          icon: "fab fa-linkedin-in",
          color: "#0072b1"
        },
        {
          url: "#",
          newWindow: "true",
          icon: "fab fa-xing",
          color: "#007e7e"
        },
        {
          url: "#",
          newWindow: "true",
          icon: "fab fa-facebook-f",
          color: "#3c5598"
        },
        {
          url: "#",
          newWindow: "true",
          icon: "fab fa-instagram",
          color: "#DD2A7B"
        }
      ]
    };
  }
};
</script>

<style module lang="scss">
@import "./Footer.scss";
</style>
